import { createSlice, isAnyOf, PayloadAction } from "@reduxjs/toolkit";

import { IntegrationAxios } from "../../axios/integration/integration.axios";
import { Integration } from "../../model/integration/Integration";
import { CreateIntegrationDto } from "../../model/integration/dto/CreateIntegrationDto";
import { FacebookIntegrationDto } from "../../model/integration/dto/FacebookIntegrationDto";
import { IntegrationFBFinishFieldResolveFinalizeDto } from "../../model/integration/dto/IntegrationFBFinishFieldResolveFinalizeDto";
import { IntegrationFBStartFieldResolveResponseDto } from "../../model/integration/dto/IntegrationFBStartFieldResolveResponseDto";
import { UpdateIntegrationDto } from "../../model/integration/dto/UpdateIntegrationDto";
import { WhatsappIntegrationDto } from "../../model/integration/dto/WhatsappIntegrationDto";
import { IntegrationKind } from "../../model/integration/types/IntegrationKind";
import { IntegrationConfigWhatsapp } from "../../model/integration/types/config/IntegrationConfigWhatsapp";
import { GenericWithUserId } from "../../model/shared/dto/GenericWithUserId";
import { AtiraThunk } from "../AtiraThunk";
import { userActions } from "../user/user.slice";
import { revertAllReduxAction } from "../store-reset";
import { WhatsappMetaIntegrationDto } from "../../model/integration/dto/WhatsappMetaIntegrationDto";
import { WhatsappDirectChatIntegrationDto } from "../../model/integration/dto/WhatsappDirectChatIntegrationDto";
import { WhatsappDirectGetQRDto } from "../../model/integration/dto/WhatsappDirectGetQRDto";
import { WhatsappDirectGetQRResponseDto } from "../../model/integration/dto/WhatsappDirectGetQRResponseDto";
import { WhatsappDirectSyncStatusDto } from "../../model/integration/dto/WhatsappDirectSyncStatusDto";
import { WaslaChat } from "../../model/integration/dto/WaslaChat";
import { WaslaGetChatsListDto } from "../../model/integration/dto/WaslaGetChatsListDto";
import { WaslaGetChatsListResponseDto } from "../../model/integration/dto/WaslaGetChatsListResponseDto";
import { WaslaGetChatMessagesDto } from "../../model/integration/dto/WaslaGetChatMessagesDto";
import { WaslaGetChatMessagesResponseDto } from "../../model/integration/dto/WaslaGetChatMessagesResponseDto";
import { WaslaGetChatDetailsResponseDto } from "../../model/integration/dto/WaslaGetChatDetailsResponseDto";
import { WaslaGetChatDetailsDto } from "../../model/integration/dto/WaslaGetChatDetailsDto";
import { WaslaSendChatMessageDto } from "../../model/integration/dto/WaslaSendChatMessageDto";
import { WaslaMarkChatAsReadDto } from "../../model/integration/dto/WaslaMarkChatAsReadDto";
import { WaslaConversationCreateNoteDto } from "../../model/integration/dto/WaslaConversationCreateNoteDto";
import { MetaGetChatsListDto } from "../../model/integration/dto/meta/MetaGetChatsListDto";
import { MetaGetChatsListResponseDto } from "../../model/integration/dto/meta/MetaGetChatsListResponseDto";
import { Conversation } from "../../model/integration/dto/meta/MetaConversation";
import { MetaGetChatDto } from "../../model/integration/dto/meta/MetaGetChatDto";
import {
  byRecency,
  chatNeedsAttention,
  chatRecency,
} from "../../routes/integration/utils/integration-utils";
import { MetaSendMessageDto } from "../../model/integration/dto/meta/MetaSendMessageDto";
import { ConversationMessage } from "../../model/integration/dto/meta/MetaConversationMessage";
import { MetaMessageTemplate } from "../../model/integration/dto/meta/MetaMessageTemplate";
import { MetaGetMediaStorageDto } from "../../model/integration/dto/meta/MetaGetMediaStorageDto";
import { MetaGetNumberHealthDto } from "../../model/integration/dto/meta/MetaGetNumberHealthDto";
import { MetaMediaStorageResponseDto } from "../../model/integration/dto/meta/MetaMediaStorageResponseDto";
import { WhatsappCampaignActionDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignActionDto";
import { WhatsappCampaignCreateDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignCreateDto";
import { WhatsappCampaignListDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignListDto";
import { WhatsappCampaignResponseDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignResponseDto";
import { WhatsappCampaignUpdateDto } from "../../model/integration/dto/whatsapp-campaign/WhatsappCampaignUpdateDto";
import { MetaGetTemplatesDto } from "../../model/integration/dto/meta/MetaGetTemplatesDto";
import { MetaNumberHealthResponseDto } from "../../model/integration/dto/meta/MetaNumberHealthResponseDto";
import { DeleteIntegrationDto } from "../../model/integration/dto/DeleteIntegrationDto";
import { MetaMarkChatAsReadDto } from "../../model/integration/dto/meta/MetaMarkChatAsReadDto";
import { MetaIncrementChatUnreadCountDto } from "../../model/integration/dto/meta/MetaIncrementChatUnreadCountDto";
import { MetaCreateConversationDto } from "../../model/integration/dto/meta/MetaCreateConversationDto";
import { MetaConversationAssignDto } from "../../model/integration/dto/meta/MetaConversationAssignDto";
import { MetaConversationTagsDto } from "../../model/integration/dto/meta/MetaConversationTagsDto";
import { MetaConversationHandoverDto } from "../../model/integration/dto/meta/MetaConversationHandoverDto";
import {
  MetaGetMessagesDto,
  MetaGetMessagesResponseDto,
} from "../../model/integration/dto/meta/MetaGetMessagesDto";
import { MetaSendMediaDto } from "../../model/integration/dto/meta/MetaSendMediaDto";
import {
  MetaDeleteMessageDto,
  MetaReactToMessageDto,
} from "../../model/integration/dto/meta/MetaMessageActionDto";
import { WhatsappMetaAIAgentDeleteDto } from "../../model/integration/dto/meta/WhatsappMetaAIAgentDeleteDto";
import { WhatsappMetaAIAgentDto } from "../../model/integration/dto/meta/WhatsappMetaAIAgentDto";
import { WhatsappMetaAutoAssignDto } from "../../model/integration/dto/meta/WhatsappMetaAutoAssignDto";
import { MetaConversationCommentsDto } from "../../model/integration/dto/meta/MetaConversationCommentsDto";
import { ConversationComment } from "../../model/integration/dto/meta/MetaConversationComment";
import { MetaConversationCommentsResponseDto } from "../../model/integration/dto/meta/MetaConversationCommentsResponseDto";
import { MetaConversationCommentCreateDto } from "../../model/integration/dto/meta/MetaConversationCommentCreateDto";
import { MetaConversationCommentUpdateDto } from "../../model/integration/dto/meta/MetaConversationCommentUpdateDto";
import { MetaConversationCommentDeleteDto } from "../../model/integration/dto/meta/MetaConversationCommentDeleteDto";
import { FacebookMetaConnectDto } from "../../model/integration/dto/facebook-meta/FacebookMetaConnectDto";
import { FacebookMetaFetchLeadsDto } from "../../model/integration/dto/facebook-meta/FacebookMetaFetchLeadsDto";
import { FacebookMetaFetchLeadsResponseDto } from "../../model/integration/dto/facebook-meta/FacebookMetaFetchLeadsResponseDto";
import { FacebookMetaListFormsResponseDto } from "../../model/integration/dto/facebook-meta/FacebookMetaListFormsResponseDto";
import { FacebookMetaLinkFormDto } from "../../model/integration/dto/facebook-meta/FacebookMetaLinkFormDto";
import { FacebookMetaListFormsDto } from "../../model/integration/dto/facebook-meta/FacebookMetaListFormsDto";
import { FacebookMetaUnlinkFormDto } from "../../model/integration/dto/facebook-meta/FacebookMetaUnlinkFormDto";
import { IntegrationConfigFacebookMeta } from "../../model/integration/types/config/IntegrationConfigFacebookMeta";
import { GoogleDriveCallbackDto } from "../../model/integration/dto/google-drive/GoogleDriveCallbackDto";
import { GoogleDriveCallbackResponseDto } from "../../model/integration/dto/google-drive/GoogleDriveCallbackResponseDto";
import { GoogleDriveCreateFileDto } from "../../model/integration/dto/google-drive/GoogleDriveCreateFileDto";
import { GoogleDriveFileDto } from "../../model/integration/dto/google-drive/GoogleDriveFileDto";
import { GoogleDriveFileOrDeleteDto } from "../../model/integration/dto/google-drive/GoogleDriveFileOrDeleteDto";
import { GoogleDriveListFilesDto } from "../../model/integration/dto/google-drive/GoogleDriveListFilesDto";
import { GoogleDrivePickerRootsDto } from "../../model/integration/dto/google-drive/GoogleDrivePickerRootsDto";
import { GoogleDriveUpdateFileDto } from "../../model/integration/dto/google-drive/GoogleDriveUpdateFileDto";
import { IntegrationConfigGoogleDrive } from "../../model/integration/types/config/IntegrationConfigGoogleDrive";

interface IntegrationReducer {
  integrations: Integration<any>[];
  integrationsLoading?: boolean;
  whatsAppIntegration?: Integration<IntegrationConfigWhatsapp>;
  //
  integrationFBResolveFieldsData?: IntegrationFBStartFieldResolveResponseDto;
  //
  whatsappIntegrationDirectChatsList: WaslaChat[];
  whatsappIntegrationDirectChatsListMeta: Record<
    string,
    {
      picUrl?: string;
      unreadCount?: number;
    }
  >;
  whatsappIntegrationDirectChatsListLoading: boolean;
  //
  chatMessages: {
    loading: boolean;
    entities: Record<string, WaslaGetChatMessagesResponseDto>;
  };
  //
  whatsappIntegrationMetaChatsList: Conversation[];
  whatsappIntegrationMetaChatsListLoading: boolean;
  /** The first page has arrived at least once, so a chat missing from the list
   * is missing rather than not loaded yet
   */
  whatsappIntegrationMetaChatsListLoaded: boolean;
  /** Where the next page of the inbox starts. Absent once the end is reached. */
  whatsappIntegrationMetaChatsListNextCursor?: string;
  /** How far down the inbox the pages reach, as the last chat's recency; null
   * once they reach the end. A chat a search or a link brought in from further
   * down is held, but not listed until paging gets there - listed early, it
   * sat below the first page with a gap above it that read as lost chats.
   */
  whatsappIntegrationMetaChatsListReachedAt: number | null;
  whatsappIntegrationMetaChatsListLoadingMore: boolean;
  /** What the inbox holds beyond the pages loaded so far, so the badges count
   * the whole inbox. Live changes to the chats in hand adjust the badges
   * themselves; this only covers the rest.
   */
  whatsappIntegrationMetaChatsElsewhere: {
    unread: number;
    needsAttention: number;
  };
  /** A search or the attention filter, which the server answers across the
   * whole inbox. Holds the chats' ids only: the chats themselves live in the
   * list above, so a live update reaches them from there.
   */
  whatsappIntegrationMetaChatsView: {
    key: string;
    ids: string[];
    nextCursor?: string;
    loading: boolean;
    loadingMore: boolean;
  } | null;
  whatsappIntegrationMetaTemplates: MetaMessageTemplate[];
  whatsappIntegrationMetaMessagesPaging: Record<
    string,
    { hasMore: boolean; loading: boolean; loaded?: boolean }
  >;
  /** Each chat's comments, newest first. Kept apart from the thread's messages
   * because the thread only ever holds a page, and the drawer lists them all.
   */
  whatsappIntegrationMetaComments: Record<string, ConversationComment[]>;
  whatsappIntegrationMetaNumberHealth?: MetaNumberHealthResponseDto;
  whatsappIntegrationMetaMediaStorage?: MetaMediaStorageResponseDto;
  whatsappIntegrationMetaCampaigns: WhatsappCampaignResponseDto[];
  whatsappIntegrationMetaCampaignsLoaded: boolean;
  //
  googleDriveFiles: GoogleDriveFileDto[];
  googleDriveFilesLoading: boolean;
  googleDriveFileActionLoading: boolean;
}

const initialState = Object.freeze<IntegrationReducer>({
  integrations: [],
  integrationsLoading: false,
  whatsAppIntegration: undefined,
  integrationFBResolveFieldsData: undefined,
  whatsappIntegrationDirectChatsList: [],
  whatsappIntegrationDirectChatsListMeta: {},
  whatsappIntegrationDirectChatsListLoading: false,
  chatMessages: {
    loading: false,
    entities: {},
  },
  whatsappIntegrationMetaChatsList: [],
  whatsappIntegrationMetaChatsListLoading: false,
  whatsappIntegrationMetaChatsListLoaded: false,
  whatsappIntegrationMetaChatsListNextCursor: undefined,
  whatsappIntegrationMetaChatsListReachedAt: null,
  whatsappIntegrationMetaChatsListLoadingMore: false,
  whatsappIntegrationMetaChatsElsewhere: { unread: 0, needsAttention: 0 },
  whatsappIntegrationMetaChatsView: null,
  whatsappIntegrationMetaTemplates: [],
  whatsappIntegrationMetaMessagesPaging: {},
  whatsappIntegrationMetaComments: {},
  whatsappIntegrationMetaNumberHealth: undefined,
  whatsappIntegrationMetaMediaStorage: undefined,
  whatsappIntegrationMetaCampaigns: [],
  whatsappIntegrationMetaCampaignsLoaded: false,
  googleDriveFiles: [],
  googleDriveFilesLoading: false,
  googleDriveFileActionLoading: false,
});

const createIntegration = AtiraThunk<
  void,
  CreateIntegrationDto<
    | FacebookIntegrationDto
    | WhatsappIntegrationDto
    | WhatsappMetaIntegrationDto
    | WhatsappDirectChatIntegrationDto
  >
>(`/integration/create`, IntegrationAxios.createIntegration);

const updateIntegration = AtiraThunk<
  void,
  UpdateIntegrationDto<
    | FacebookIntegrationDto
    | WhatsappIntegrationDto
    | WhatsappMetaIntegrationDto
    | WhatsappDirectChatIntegrationDto
  >
>(`/integration/update`, IntegrationAxios.updateIntegration);

const getUserIntegrations = AtiraThunk<Integration<any>[], GenericWithUserId>(
  `/integration`,
  IntegrationAxios.getUserIntegrations,
);

const startFBWebhookFinalizeFields = AtiraThunk<
  IntegrationFBStartFieldResolveResponseDto,
  string
>(
  `/integration/start-fields-resolve`,
  IntegrationAxios.startFBWebhookFinalizeFields,
);

const finishFBWebhookFinalizeFields = AtiraThunk<
  void,
  IntegrationFBFinishFieldResolveFinalizeDto
>(
  `/integration/finish-fields-resolve`,
  IntegrationAxios.finishFBWebhookFinalizeFields,
);

const getWhatsAppDirectQR = AtiraThunk<
  WhatsappDirectGetQRResponseDto,
  WhatsappDirectGetQRDto
>(`/integration/whatsapp-direct/qr`, IntegrationAxios.getWhatsAppDirectQR);

const syncWhatsappDirectStatus = AtiraThunk<void, WhatsappDirectSyncStatusDto>(
  `/integration/whatsapp-direct/sync`,
  IntegrationAxios.syncWhatsappDirectStatus,
);

const getWhatsAppDirectChatsList = AtiraThunk<
  WaslaGetChatsListResponseDto,
  WaslaGetChatsListDto
>(
  `/integration/whatsapp-direct/chats`,
  IntegrationAxios.getWhatsAppDirectChatsList,
);

const getWhatsAppDirectChatDetails = AtiraThunk<
  WaslaGetChatDetailsResponseDto,
  WaslaGetChatDetailsDto
>(
  `/integration/whatsapp-direct/chat-details`,
  IntegrationAxios.getWhatsAppDirectChatDetails,
);

const getWhatsAppDirectChatMessages = AtiraThunk<
  WaslaGetChatMessagesResponseDto,
  WaslaGetChatMessagesDto
>(
  `/integration/whatsapp-direct/chat-messages`,
  IntegrationAxios.getWhatsAppDirectChatMessages,
);

const whatsAppDirectSendMessage = AtiraThunk<void, WaslaSendChatMessageDto>(
  `/integration/whatsapp-direct/send-message`,
  IntegrationAxios.sendWhatsAppDirectMessage,
);

const disconnectWhatsAppDirect = AtiraThunk<void, WhatsappDirectSyncStatusDto>(
  `/integration/whatsapp-direct/disconnect`,
  IntegrationAxios.disconnectWhatsAppDirect,
);

const markChatAsRead = AtiraThunk<void, WaslaMarkChatAsReadDto>(
  `/integration/whatsapp-direct/mark-chat-as-read`,
  IntegrationAxios.markChatAsRead,
);

const createWhatsAppNote = AtiraThunk<void, WaslaConversationCreateNoteDto>(
  `/integration/whatsapp-direct/:chatId/create-note`,
  IntegrationAxios.createWhatsAppNote,
);

//

const getWhatsAppMetaChatsList = AtiraThunk<
  MetaGetChatsListResponseDto,
  MetaGetChatsListDto
>(
  `/integration/whatsapp-meta/chats`,
  IntegrationAxios.getWhatsAppMetaChatsList,
);

const loadMoreWhatsAppMetaChats = AtiraThunk<
  MetaGetChatsListResponseDto,
  MetaGetChatsListDto
>(
  `/integration/whatsapp-meta/chats/more`,
  IntegrationAxios.getWhatsAppMetaChatsList,
);

const getWhatsAppMetaChatsView = AtiraThunk<
  MetaGetChatsListResponseDto,
  MetaGetChatsListDto
>(
  `/integration/whatsapp-meta/chats/view`,
  IntegrationAxios.getWhatsAppMetaChatsList,
);

const getWhatsAppMetaChat = AtiraThunk<Conversation, MetaGetChatDto>(
  `/integration/whatsapp-meta/chats/one`,
  IntegrationAxios.getWhatsAppMetaChat,
);

const sendWhatsAppMetaMessage = AtiraThunk<void, MetaSendMessageDto>(
  `/integration/whatsapp-meta/send-message`,
  IntegrationAxios.sendWhatsAppMetaMessage,
);

const getWhatsaAppMetaTemplates = AtiraThunk<any, MetaGetTemplatesDto>(
  `/integration/whatsapp-meta/templates`,
  IntegrationAxios.getWhatsAppMetaTemplates,
);

const getWhatsappMetaNumberHealth = AtiraThunk<
  MetaNumberHealthResponseDto,
  MetaGetNumberHealthDto
>(
  `/integration/whatsapp-meta/number-health`,
  IntegrationAxios.getWhatsAppMetaNumberHealth,
);

const getWhatsappMetaMediaStorage = AtiraThunk<
  MetaMediaStorageResponseDto,
  MetaGetMediaStorageDto
>(
  `/integration/whatsapp-meta/media-storage`,
  IntegrationAxios.getWhatsAppMetaMediaStorage,
);

const getWhatsappMetaCampaigns = AtiraThunk<
  WhatsappCampaignResponseDto[],
  WhatsappCampaignListDto
>(
  `/integration/whatsapp-meta/campaigns`,
  IntegrationAxios.getWhatsappMetaCampaigns,
);

const createWhatsappMetaCampaign = AtiraThunk<void, WhatsappCampaignCreateDto>(
  `/integration/whatsapp-meta/campaigns/create`,
  IntegrationAxios.createWhatsappMetaCampaign,
);

const updateWhatsappMetaCampaign = AtiraThunk<void, WhatsappCampaignUpdateDto>(
  `/integration/whatsapp-meta/campaigns/update`,
  IntegrationAxios.updateWhatsappMetaCampaign,
);

const pauseWhatsappMetaCampaign = AtiraThunk<void, WhatsappCampaignActionDto>(
  `/integration/whatsapp-meta/campaigns/pause`,
  IntegrationAxios.pauseWhatsappMetaCampaign,
);

const resumeWhatsappMetaCampaign = AtiraThunk<void, WhatsappCampaignActionDto>(
  `/integration/whatsapp-meta/campaigns/resume`,
  IntegrationAxios.resumeWhatsappMetaCampaign,
);

const deleteWhatsappMetaCampaign = AtiraThunk<void, WhatsappCampaignActionDto>(
  `/integration/whatsapp-meta/campaigns/delete`,
  IntegrationAxios.deleteWhatsappMetaCampaign,
);

const disconnectIntegration = AtiraThunk<void, DeleteIntegrationDto>(
  `/integration/disconnect`,
  IntegrationAxios.disconnectIntegration,
);

const markWhatsAppMetaChatAsRead = AtiraThunk<void, MetaMarkChatAsReadDto>(
  `/integration/whatsapp-meta/chats-list/:conversationId/mark-as-read`,
  IntegrationAxios.markWhatsAppMetaChatAsRead,
);

const incrementWhatsAppMetaChatUnreadCount = AtiraThunk<
  void,
  MetaIncrementChatUnreadCountDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/increment-unread-count`,
  IntegrationAxios.incrementWhatsAppMetaChatUnreadCount,
);

const createWhatsappMetaConversation = AtiraThunk<
  Conversation,
  MetaCreateConversationDto
>(
  `/integration/whatsapp-meta/chats-list/create-conversation`,
  IntegrationAxios.createWhatsappMetaConversation,
);

const sendWhatsappMetaMedia = AtiraThunk<void, MetaSendMediaDto>(
  `/integration/whatsapp-meta/chats-list/:conversationId/media/send`,
  IntegrationAxios.sendWhatsappMetaMedia,
);

const showWhatsappMetaTyping = AtiraThunk<
  void,
  { userId: string; integrationId: string; conversationId: string }
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/typing`,
  IntegrationAxios.showWhatsappMetaTyping,
);

const getWhatsappMetaMessages = AtiraThunk<
  MetaGetMessagesResponseDto,
  MetaGetMessagesDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/messages`,
  IntegrationAxios.getWhatsappMetaMessages,
);

const deleteWhatsappMetaMessage = AtiraThunk<void, MetaDeleteMessageDto>(
  `/integration/whatsapp-meta/messages/delete`,
  IntegrationAxios.deleteWhatsappMetaMessage,
);

const reactToWhatsappMetaMessage = AtiraThunk<void, MetaReactToMessageDto>(
  `/integration/whatsapp-meta/messages/react`,
  IntegrationAxios.reactToWhatsappMetaMessage,
);

const updateWhatsappMetaAiAgent = AtiraThunk<void, WhatsappMetaAIAgentDto>(
  `/integration/whatsapp-meta/ai-agent`,
  IntegrationAxios.updateWhatsappMetaAIAgent,
);

const deleteWhatsappMetaAIAgent = AtiraThunk<
  void,
  WhatsappMetaAIAgentDeleteDto
>(
  `/integration/whatsapp-meta/ai-agent/delete`,
  IntegrationAxios.deleteWhatsappMetaAIAgent,
);

const setWhatsappMetaConversationHandler = AtiraThunk<
  void,
  MetaConversationHandoverDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/handover`,
  IntegrationAxios.setWhatsappMetaConversationHandler,
);

const assignWhatsappMetaConversation = AtiraThunk<
  void,
  MetaConversationAssignDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/manage-assignees`,
  IntegrationAxios.assignWhatsappMetaConversation,
);

const updateWhatsappMetaConversationTags = AtiraThunk<
  void,
  MetaConversationTagsDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/tags`,
  IntegrationAxios.updateWhatsappMetaConversationTags,
);

const updateWhatsappMetaAutoAssign = AtiraThunk<
  void,
  WhatsappMetaAutoAssignDto
>(
  `/integration/whatsapp-meta/auto-assign`,
  IntegrationAxios.updateWhatsappMetaAutoAssign,
);

const getWhatsappMetaComments = AtiraThunk<
  MetaConversationCommentsResponseDto,
  MetaConversationCommentsDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/comments`,
  IntegrationAxios.getWhatsappMetaComments,
);

const createWhatsappMetaComment = AtiraThunk<
  ConversationComment,
  MetaConversationCommentCreateDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/comments/create`,
  IntegrationAxios.createWhatsappMetaComment,
);

const updateWhatsappMetaComment = AtiraThunk<
  ConversationComment,
  MetaConversationCommentUpdateDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/comments/update`,
  IntegrationAxios.updateWhatsappMetaComment,
);

const deleteWhatsappMetaComment = AtiraThunk<
  void,
  MetaConversationCommentDeleteDto
>(
  `/integration/whatsapp-meta/chats-list/:conversationId/comments/delete`,
  IntegrationAxios.deleteWhatsappMetaComment,
);

//

const createGoogleDriveAuthLink = AtiraThunk<string, GenericWithUserId>(
  `/integration/google-drive/auth-link`,
  IntegrationAxios.createGoogleDriveAuthLink,
);

const googleDriveOAuthCallback = AtiraThunk<
  GoogleDriveCallbackResponseDto,
  GoogleDriveCallbackDto
>(
  `/integration/google-drive/callback`,
  IntegrationAxios.googleDriveOAuthCallback,
);

const registerGoogleDrivePickerRoots = AtiraThunk<
  Integration<IntegrationConfigGoogleDrive>,
  GoogleDrivePickerRootsDto
>(
  `/integration/google-drive/picker-roots`,
  IntegrationAxios.registerGoogleDrivePickerRoots,
);

const disconnectGoogleDrive = AtiraThunk<void, DeleteIntegrationDto>(
  `/integration/google-drive/disconnect`,
  IntegrationAxios.disconnectGoogleDrive,
);

const connectFacebookMeta = AtiraThunk<
  Integration<IntegrationConfigFacebookMeta>,
  FacebookMetaConnectDto
>(`/integration/facebook-meta/connect`, IntegrationAxios.connectFacebookMeta);

const getFacebookMetaForms = AtiraThunk<
  FacebookMetaListFormsResponseDto,
  FacebookMetaListFormsDto
>(`/integration/facebook-meta/forms`, IntegrationAxios.getFacebookMetaForms);

const linkFacebookMetaForm = AtiraThunk<void, FacebookMetaLinkFormDto>(
  `/integration/facebook-meta/forms/link`,
  IntegrationAxios.linkFacebookMetaForm,
);

const unlinkFacebookMetaForm = AtiraThunk<void, FacebookMetaUnlinkFormDto>(
  `/integration/facebook-meta/forms/unlink`,
  IntegrationAxios.unlinkFacebookMetaForm,
);

const fetchFacebookMetaLeads = AtiraThunk<
  FacebookMetaFetchLeadsResponseDto,
  FacebookMetaFetchLeadsDto
>(
  `/integration/facebook-meta/forms/fetch-leads`,
  IntegrationAxios.fetchFacebookMetaLeads,
);

const listGoogleDriveFiles = AtiraThunk<
  GoogleDriveFileDto[],
  GoogleDriveListFilesDto
>(`/integration/google-drive/files`, IntegrationAxios.listGoogleDriveFiles);

const createGoogleDriveFile = AtiraThunk<
  GoogleDriveFileDto,
  GoogleDriveCreateFileDto
>(
  `/integration/google-drive/files/create`,
  IntegrationAxios.createGoogleDriveFile,
);

const updateGoogleDriveFile = AtiraThunk<
  GoogleDriveFileDto,
  GoogleDriveUpdateFileDto
>(
  `/integration/google-drive/files/update`,
  IntegrationAxios.updateGoogleDriveFile,
);

const deleteGoogleDriveFile = AtiraThunk<void, GoogleDriveFileOrDeleteDto>(
  `/integration/google-drive/files/delete`,
  IntegrationAxios.deleteGoogleDriveFile,
);

const downloadGoogleDriveFile = AtiraThunk<Blob, GoogleDriveFileOrDeleteDto>(
  `/integration/google-drive/files/download`,
  IntegrationAxios.downloadGoogleDriveFile,
);

/** Puts a comment into its chat's list, replacing the copy already there.
 *
 * Arrives twice for whoever wrote it - once as the request's response, once
 * over the socket - and in either order, so it has to be idempotent.
 */
const upsertComment = (
  state: IntegrationReducer,
  comment: ConversationComment,
) => {
  // A persisted state from before comments existed has no map at all
  const comments =
    state.whatsappIntegrationMetaComments?.[comment.conversationId];

  // Not loaded yet: opening the chat fetches the whole list anyway
  if (!comments) {
    return;
  }

  const index = comments.findIndex((c) => c._id === comment._id);

  if (index >= 0) {
    comments[index] = comment;
  } else {
    comments.unshift(comment);
  }
};

const removeComment = (
  state: IntegrationReducer,
  target: { _id: string; conversationId: string },
) => {
  const comments =
    state.whatsappIntegrationMetaComments?.[target.conversationId];

  if (comments) {
    state.whatsappIntegrationMetaComments[target.conversationId] =
      comments.filter((c) => c._id !== target._id);
  }
};

const mergeMessage = (
  existing: ConversationMessage | undefined,
  incoming: ConversationMessage,
): ConversationMessage => {
  if (!existing) {
    return incoming;
  }

  // A deleted message is meant to have lost what it said. Topping it up from
  // the copy in hand - the rules below - would bring its attachment back.
  if (incoming.deletedAt) {
    if (existing.localPreviewUrl) {
      URL.revokeObjectURL(existing.localPreviewUrl);
    }

    return { ...incoming, sentBy: incoming.sentBy || existing.sentBy };
  }

  const next = { ...incoming };

  // A status or reaction update does not carry the sender, which is read when
  // the thread is loaded, and replacing the message with it would drop the
  // avatar the moment a tick arrived
  if (!next.sentBy && existing.sentBy) {
    next.sentBy = existing.sentBy;
  }

  // Only the retention sweep legitimately takes a mediaId away, and it says so
  // by setting an expiry
  if (!next.mediaId && !next.mediaExpiredAt && existing.mediaId) {
    next.mediaId = existing.mediaId;
  }

  if (!next.mediaId) {
    // Still the only thing that can paint this bubble
    next.localPreviewUrl = existing.localPreviewUrl;

    return next;
  }

  // Our copy is stored, so the object URL is dead weight - it pins the whole
  // file in memory until the tab is closed
  if (existing.localPreviewUrl) {
    URL.revokeObjectURL(existing.localPreviewUrl);
  }

  // A client-built payload is spread from a message in state, so it can be
  // carrying the very URL just revoked. Nothing produces that combination
  // today - this keeps the rule true on its own terms rather than on an
  // invariant held somewhere else.
  delete next.localPreviewUrl;

  return next;
};

/** Moves the chat's summary - the line the inbox row previews, and the time it
 * sorts on - onto the message that just arrived.
 *
 * The server keeps these fields on the conversation and sends a new message on
 * its own: no conversation.update follows a message.in or a message.out. So
 * without this the row kept whatever the list was fetched with. It looked like
 * it worked for our own attachments only because the delivery receipts that
 * trail an outgoing message do carry a conversation.update - and an incoming
 * reply has no receipts, which is why the row sat on the sent document until
 * something refetched the list.
 */
const chatsViewKey = (dto: {
  search?: string;
  needsAttention?: boolean;
  tagIds?: string[];
}) =>
  JSON.stringify([
    (dto.search || "").trim(),
    Boolean(dto.needsAttention),
    [...(dto.tagIds || [])].sort(),
  ]);

const lastHeardAt = (chat: Pick<Conversation, "lastMessageAt">) =>
  new Date(chat.lastMessageAt || "").getTime() || 0;

/** A fetch is a picture of the server a moment ago, and a live event may have
 * reached this client since. The row that knows of the later message wins, so
 * a refresh cannot rewind a chat to before something that was just said.
 */
const notOlder = (incoming: Conversation, held?: Conversation) =>
  held && lastHeardAt(held) > lastHeardAt(incoming) ? held : incoming;

/** Takes chats the server sent into the list, keeping the messages a thread has
 * already loaded. Whatever was not in hand before is now accounted for, so it
 * stops counting towards what the inbox holds beyond the loaded pages.
 */
const absorbChats = (state: IntegrationReducer, chats: Conversation[]) => {
  const known = new Map(
    state.whatsappIntegrationMetaChatsList.map((chat) => [chat._id, chat]),
  );

  let unread = 0;
  let needsAttention = 0;

  const incoming = chats.map((chat) => {
    if (!known.has(chat._id)) {
      unread += chat.unreadCount || 0;
      needsAttention += chatNeedsAttention(chat) ? 1 : 0;
    }

    const fresher = notOlder(chat, known.get(chat._id));

    return {
      ...fresher,
      messages: fresher.messages?.length
        ? fresher.messages
        : known.get(chat._id)?.messages || [],
    };
  });

  const incomingIds = new Set(incoming.map((chat) => chat._id));
  const elsewhere = state.whatsappIntegrationMetaChatsElsewhere;

  elsewhere.unread = Math.max(0, elsewhere.unread - unread);
  elsewhere.needsAttention = Math.max(
    0,
    elsewhere.needsAttention - needsAttention,
  );

  state.whatsappIntegrationMetaChatsList = [
    ...state.whatsappIntegrationMetaChatsList.filter(
      (chat) => !incomingIds.has(chat._id),
    ),
    ...incoming,
  ].sort(byRecency) as any;
};

const applyMessageToSummary = (
  chat: Conversation,
  message: ConversationMessage,
): Conversation => {
  const at = Number(message.timestamp) * 1000;

  // Messages do arrive out of order - a retried webhook, a slow media upload -
  // and an older one must not rewind the row or drag the chat back down the
  // list. Same rule the server applies to its own copy.
  if (
    !Number.isFinite(at) ||
    at < (new Date(chat.lastMessageAt || "").getTime() || 0)
  ) {
    return chat;
  }

  return {
    ...chat,
    lastMessageId: message._id,
    // Media has no text; the row falls back to a label for the type
    lastMessage: message.type === "text" ? message.text?.body || "" : "",
    lastMessageType: message.type,
    lastDirection: message.direction,
    lastMessageStatus: message.status,
    lastMessageAt: new Date(at),
  };
};

/** Puts a fresh copy of an integration into the list, replacing it if the
 * list already has one - used after connecting Drive and after registering
 * Picker roots so the UI reflects the new state without a full refetch.
 */
const upsertIntegration = (
  state: IntegrationReducer,
  integration: Integration<any>,
) => {
  const index = state.integrations.findIndex(
    (existing) => existing._id === integration._id,
  );

  if (index >= 0) {
    state.integrations[index] = integration;
  } else {
    state.integrations.push(integration);
  }
};

const integrationSlice = createSlice({
  name: "integration",
  initialState,
  reducers: {
    emptyFBTempWebhook: (state) => {
      state.integrationFBResolveFieldsData = undefined;
    },

    metaClearChatsView: (state) => {
      state.whatsappIntegrationMetaChatsView = null;
    },

    metaAppendOUTMessage: (
      state,
      action: PayloadAction<ConversationMessage>,
    ) => {
      const _newChat = state.whatsappIntegrationMetaChatsList.find(
        (chat) => chat._id === action.payload.conversationId,
      );

      if (!_newChat) {
        return;
      }

      const newChat = { ..._newChat };
      const messages = newChat.messages || (newChat.messages = []);

      // Matched on the id the sender minted and the API echoed back. Matching
      // on "the first pending attachment" instead meant a teammate's outgoing
      // media - message.out goes to everyone on the integration - took over
      // this client's bubble, inherited its preview, and left the real one to
      // arrive as a duplicate.
      const placeholderIndex = action.payload.clientId
        ? messages.findIndex(
            (msg) => msg.pending && msg._id === action.payload.clientId,
          )
        : -1;

      if (placeholderIndex >= 0) {
        messages[placeholderIndex] = {
          ...action.payload,
          localPreviewUrl: messages[placeholderIndex].localPreviewUrl,
        };
      } else {
        messages.push(action.payload);
      }

      const updated = applyMessageToSummary(newChat, action.payload);

      state.whatsappIntegrationMetaChatsList = [
        ...state.whatsappIntegrationMetaChatsList,
      ]
        .map((chat) => (chat._id === newChat._id ? updated : chat))
        .sort(byRecency);
    },

    metaAppendLocalMessage: (
      state,
      action: PayloadAction<ConversationMessage>,
    ) => {
      const chat = state.whatsappIntegrationMetaChatsList.find(
        (c) => c._id === action.payload.conversationId,
      );

      if (!chat) {
        return;
      }

      (chat.messages || (chat.messages = [])).push(action.payload);
    },

    metaAppendINMessage: (
      state,
      action: PayloadAction<ConversationMessage>,
    ) => {
      const _newChat = state.whatsappIntegrationMetaChatsList.find(
        (chat) => chat._id === action.payload.conversationId,
      );

      if (!_newChat) {
        return;
      }

      const newChat = { ..._newChat };

      (newChat.messages || (newChat.messages = [])).push(action.payload);

      const updated = applyMessageToSummary(newChat, action.payload);

      state.whatsappIntegrationMetaChatsList = [
        ...state.whatsappIntegrationMetaChatsList,
      ]
        .map((chat) => (chat._id === newChat._id ? updated : chat))
        .sort(byRecency);
    },

    /** socket: `message.delete` - the message stays in the thread, emptied */
    metaMarkMessageDeleted: (
      state,
      action: PayloadAction<ConversationMessage>,
    ) => {
      const deleted = action.payload;
      const chat = state.whatsappIntegrationMetaChatsList.find(
        (c) => c._id === deleted.conversationId,
      );

      if (!chat) {
        return;
      }

      chat.messages = (chat.messages || []).map((message) => {
        if (message._id !== deleted._id) {
          return message;
        }

        if (message.localPreviewUrl) {
          URL.revokeObjectURL(message.localPreviewUrl);
        }

        return deleted;
      });

      if (chat.lastMessageId === deleted._id) {
        chat.lastMessageType = "deleted";
        chat.lastMessage = "";
      }
    },

    metaRemoveMessage: (
      state,
      action: PayloadAction<{ _id: string; conversationId: string }>,
    ) => {
      const chat = state.whatsappIntegrationMetaChatsList.find(
        (c) => c._id === action.payload.conversationId,
      );

      if (!chat) {
        return;
      }

      const removed = (chat.messages || []).find(
        (m) => m._id === action.payload._id,
      );

      if (removed?.localPreviewUrl) {
        URL.revokeObjectURL(removed.localPreviewUrl);
      }

      chat.messages = (chat.messages || []).filter(
        (m) => m._id !== action.payload._id,
      );
    },

    metaSetMessagesLoading: (
      state,
      action: PayloadAction<{ conversationId: string; loading: boolean }>,
    ) => {
      if (!action.payload.conversationId) {
        return;
      }

      const current =
        state.whatsappIntegrationMetaMessagesPaging[
          action.payload.conversationId
        ];

      state.whatsappIntegrationMetaMessagesPaging[
        action.payload.conversationId
      ] = {
        hasMore: current?.hasMore ?? true,
        loading: action.payload.loading,
        loaded: current?.loaded,
      };
    },

    /** Replaces a conversation's messages with what the server just returned.
     *
     * Merging would never drop anything, so a message someone deleted from
     * another machine stayed on screen here forever. The server decides which
     * messages exist; the client-only fields survive for the ones that remain.
     */
    metaSetMessages: (
      state,
      action: PayloadAction<{
        conversationId: string;
        messages: ConversationMessage[];
        hasMore: boolean;
      }>,
    ) => {
      const chat = state.whatsappIntegrationMetaChatsList.find(
        (c) => c._id === action.payload.conversationId,
      );

      // Nowhere to put them, so the thread is not loaded - marked loaded, it
      // read as a chat with no messages and was never asked for again
      if (!chat) {
        delete state.whatsappIntegrationMetaMessagesPaging[
          action.payload.conversationId
        ];
        return;
      }

      state.whatsappIntegrationMetaMessagesPaging[
        action.payload.conversationId
      ] = { hasMore: action.payload.hasMore, loading: false, loaded: true };

      const previous = new Map(
        (chat.messages || []).map((message) => [message._id, message]),
      );
      const arriving = new Set(
        action.payload.messages.map((message) => message._id),
      );

      // An attachment still uploading has no server id yet, so the server
      // cannot know about it and dropping it would blank the bubble mid-send
      const stillSending = (chat.messages || []).filter(
        (message) => message.pending,
      );

      // Anything the server no longer has is gone for good, so its preview is
      // dead weight
      previous.forEach((message, id) => {
        if (!message.pending && message.localPreviewUrl && !arriving.has(id)) {
          URL.revokeObjectURL(message.localPreviewUrl);
        }
      });

      chat.messages = [
        ...action.payload.messages.map((message) =>
          mergeMessage(previous.get(message._id), message),
        ),
        ...stillSending,
      ];
    },

    metaPrependMessages: (
      state,
      action: PayloadAction<{
        conversationId: string;
        messages: ConversationMessage[];
        hasMore: boolean;
      }>,
    ) => {
      const chat = state.whatsappIntegrationMetaChatsList.find(
        (c) => c._id === action.payload.conversationId,
      );

      state.whatsappIntegrationMetaMessagesPaging[
        action.payload.conversationId
      ] = { hasMore: action.payload.hasMore, loading: false, loaded: true };

      if (!chat) {
        return;
      }

      const byId = new Map(
        [...action.payload.messages, ...(chat.messages || [])].map(
          (message) => [message._id, message],
        ),
      );

      chat.messages = Array.from(byId.values());
    },

    metaUpdateMessage: (state, action) => {
      const _newChat = state.whatsappIntegrationMetaChatsList.find(
        (chat) => chat._id === action.payload.conversationId,
      );

      if (!_newChat) {
        return;
      }

      const newChat = { ..._newChat };

      newChat.messages = (newChat.messages || []).map((msg) => {
        if (msg._id !== action.payload._id) {
          return msg;
        }

        return mergeMessage(msg, action.payload);
      });

      // The row's ticks read the summary, not the thread, so a receipt for the
      // newest message has to land there too - the chat list is usually open
      // without that message ever having been loaded
      if (newChat.lastMessageId === action.payload._id) {
        newChat.lastMessageStatus = action.payload.status;
      }

      state.whatsappIntegrationMetaChatsList = [
        ...state.whatsappIntegrationMetaChatsList,
      ]
        .map((chat) => (chat._id === newChat._id ? newChat : chat))
        .sort(byRecency);
    },

    metaInsertConversation: (state, action) => {
      const _newChat = state.whatsappIntegrationMetaChatsList.find(
        (chat) => chat._id === action.payload._id,
      );

      if (_newChat) {
        return;
      }

      state.whatsappIntegrationMetaChatsList = [
        ...state.whatsappIntegrationMetaChatsList,
        action.payload,
      ].sort(byRecency);
    },

    metaUpdateConversation: (state, action) => {
      const _newChat = state.whatsappIntegrationMetaChatsList.find(
        (chat) => chat._id === action.payload._id,
      );

      if (!_newChat) {
        return;
      }

      // A populated conversation.update carries the server's copy of every
      // message, which would otherwise overwrite an attachment still being
      // painted from memory - the customer replying while a photo of ours
      // uploads is all it takes
      const byId = new Map(
        (_newChat.messages || []).map((message) => [message._id, message]),
      );

      for (const message of (action.payload.messages ||
        []) as ConversationMessage[]) {
        byId.set(message._id, mergeMessage(byId.get(message._id), message));
      }

      const newChat = {
        ..._newChat,
        ...action.payload,
        messages: Array.from(byId.values()),
      };

      state.whatsappIntegrationMetaChatsList = [
        ...state.whatsappIntegrationMetaChatsList,
      ]
        .map((chat) => (chat._id === newChat._id ? newChat : chat))
        .sort(byRecency);
    },

    metaRemoveConversation: (state, action: PayloadAction<{ _id: string }>) => {
      const chat = state.whatsappIntegrationMetaChatsList.find(
        (c) => c._id === action.payload._id,
      );

      (chat?.messages || []).forEach((message) => {
        if (message.localPreviewUrl) {
          URL.revokeObjectURL(message.localPreviewUrl);
        }
      });

      state.whatsappIntegrationMetaChatsList =
        state.whatsappIntegrationMetaChatsList.filter(
          (c) => c._id !== action.payload._id,
        );

      delete state.whatsappIntegrationMetaMessagesPaging[action.payload._id];

      if (state.whatsappIntegrationMetaComments) {
        delete state.whatsappIntegrationMetaComments[action.payload._id];
      }
    },

    /** socket: `comment.created` and `comment.updated` */
    metaUpsertComment: (state, action: PayloadAction<ConversationComment>) => {
      upsertComment(state, action.payload);
    },

    /** socket: `comment.deleted` */
    metaRemoveComment: (
      state,
      action: PayloadAction<{ _id: string; conversationId: string }>,
    ) => {
      removeComment(state, action.payload);
    },

    metaSetUnreadConversationCount: (state, action) => {
      const _newChat = state.whatsappIntegrationMetaChatsList.find(
        (chat) => chat._id === action.payload._id,
      );

      if (!_newChat) {
        return;
      }

      _newChat.unreadCount = action.payload.unreadCount || 0;

      state.whatsappIntegrationMetaChatsList = [
        ...state.whatsappIntegrationMetaChatsList,
      ]
        .map((chat) => (chat._id === _newChat._id ? _newChat : chat))
        .sort(byRecency);
    },
  },

  extraReducers: ({ addCase, addMatcher }) => {
    addCase(getUserIntegrations.pending, (state, action) => {
      state.integrationsLoading = true;
    });
    addCase(getUserIntegrations.fulfilled, (state, action) => {
      state.integrationsLoading = false;
      state.integrations = action.payload;
      state.whatsAppIntegration = action.payload.find(
        (integration) => integration.kind === IntegrationKind.WHATSAPP,
      ) as Integration<IntegrationConfigWhatsapp>;
    });
    addCase(getUserIntegrations.rejected, (state, action) => {
      state.integrationsLoading = false;
    });

    addCase(startFBWebhookFinalizeFields.fulfilled, (state, action) => {
      state.integrationFBResolveFieldsData = action.payload;
    });

    addCase(getWhatsAppDirectChatsList.pending, (state, action) => {
      state.whatsappIntegrationDirectChatsListLoading = true;
    });
    addCase(getWhatsAppDirectChatsList.fulfilled, (state, action) => {
      state.whatsappIntegrationDirectChatsListLoading = false;
      state.whatsappIntegrationDirectChatsList = action.payload.chats;
    });
    addCase(getWhatsAppDirectChatsList.rejected, (state, action) => {
      state.whatsappIntegrationDirectChatsListLoading = false;
    });

    addCase(getWhatsAppDirectChatMessages.pending, (state, action) => {
      if (!state.chatMessages) {
        state.chatMessages = {
          loading: false,
          entities: {},
        };
      }

      state.chatMessages.loading = true;
    });
    addCase(getWhatsAppDirectChatMessages.fulfilled, (state, action) => {
      state.chatMessages.loading = false;

      const incomingMessages = action.payload.messages.messages || [];
      const existingMessages = (
        state.chatMessages.entities[action.payload.id]?.messages.messages || []
      ).filter((msg) => msg?.atiraMeta?.optimistic !== true);

      const existingIds = new Set(existingMessages.map((m) => m.msgId));
      const merged = [...existingMessages];

      for (const msg of incomingMessages) {
        if (!existingIds.has(msg.msgId)) {
          merged.push(msg);
        }
      }

      state.chatMessages.entities[action.payload.id] = {
        ...action.payload,
        id: action.payload.id,
        messages: {
          noEarlierMsgs: action.payload.messages.noEarlierMsgs,
          messages: merged.sort((a, b) => a.timestamp - b.timestamp),
        },
      };
    });
    addCase(getWhatsAppDirectChatMessages.rejected, (state, action) => {
      state.chatMessages.loading = false;
    });

    addCase(disconnectWhatsAppDirect.fulfilled, (state, action) => {
      state.whatsappIntegrationDirectChatsList = [];
      state.whatsappIntegrationDirectChatsListMeta = {};
      state.chatMessages = {
        loading: false,
        entities: {},
      };
    });

    addCase(getWhatsAppDirectChatDetails.fulfilled, (state, action) => {
      if (!state.whatsappIntegrationDirectChatsListMeta) {
        state.whatsappIntegrationDirectChatsListMeta = {};
      }

      const target =
        state.whatsappIntegrationDirectChatsListMeta?.[action.payload.id];

      if (!target) {
        state.whatsappIntegrationDirectChatsListMeta[action.payload.id] = {
          picUrl: action.payload.picUrl,
        };
      } else {
        state.whatsappIntegrationDirectChatsListMeta[action.payload.id] = {
          ...target,
          picUrl: action.payload.picUrl,
        };
      }
    });

    addCase(getWhatsAppMetaChatsList.pending, (state, action) => {
      state.whatsappIntegrationMetaChatsListLoading = true;
    });
    addCase(getWhatsAppMetaChatsList.fulfilled, (state, action) => {
      // Read before it is set: chats held before the first page ever landed
      // are not deeper pages
      const wasLoaded = state.whatsappIntegrationMetaChatsListLoaded;

      state.whatsappIntegrationMetaChatsListLoading = false;
      state.whatsappIntegrationMetaChatsListLoaded = true;

      const { chats = [], nextCursor, summary } = action.payload;
      const previousCursor = state.whatsappIntegrationMetaChatsListNextCursor;
      const previousReachedAt = state.whatsappIntegrationMetaChatsListReachedAt;
      const previous = new Map(
        state.whatsappIntegrationMetaChatsList.map((chat) => [chat._id, chat]),
      );
      const incomingIds = new Set(chats.map((chat) => chat._id));

      // The list no longer carries messages, so replacing it wholesale threw
      // away every thread already loaded - on a reload that meant the messages
      // appeared, vanished when this landed, and were fetched all over again.
      const incoming = chats.map((chat) => {
        const fresher = notOlder(chat, previous.get(chat._id));

        return {
          ...fresher,
          messages: fresher.messages?.length
            ? fresher.messages
            : previous.get(chat._id)?.messages || [],
        };
      });

      // A page that ends the inbox is all of it. One that does not says
      // nothing about chats further down, which stay: the one open on screen
      // may be older than this page, and dropping it closed the window.
      // Anything newer than the page's last chat that is not in it is gone.
      const oldest = chats.length
        ? Math.min(...chats.map((chat) => chatRecency(chat)))
        : 0;

      const kept = nextCursor
        ? state.whatsappIntegrationMetaChatsList.filter(
            (chat) => !incomingIds.has(chat._id) && chatRecency(chat) <= oldest,
          )
        : [];

      state.whatsappIntegrationMetaChatsList = [...incoming, ...kept].sort(
        byRecency,
      ) as any;

      // Refreshing the first page must not walk the reader back to it. When
      // deeper pages are already held, the cursor stays where those pages end
      // (or stays absent, if they ended the inbox); it is a position in the
      // ranking, so it is still right.
      const heldDeeper = wasLoaded && kept.length > 0;

      state.whatsappIntegrationMetaChatsListNextCursor = heldDeeper
        ? previousCursor
        : nextCursor;
      state.whatsappIntegrationMetaChatsListReachedAt = heldDeeper
        ? previousReachedAt
        : nextCursor
          ? oldest
          : null;

      if (summary) {
        const list = state.whatsappIntegrationMetaChatsList;

        state.whatsappIntegrationMetaChatsElsewhere = {
          unread: Math.max(
            0,
            summary.unread -
              list.reduce((total, chat) => total + (chat.unreadCount || 0), 0),
          ),
          needsAttention: Math.max(
            0,
            summary.needsAttention - list.filter(chatNeedsAttention).length,
          ),
        };
      }
    });
    addCase(getWhatsAppMetaChatsList.rejected, (state, action) => {
      state.whatsappIntegrationMetaChatsListLoading = false;
      state.whatsappIntegrationMetaChatsListLoaded = true;
    });

    addCase(loadMoreWhatsAppMetaChats.pending, (state) => {
      state.whatsappIntegrationMetaChatsListLoadingMore = true;
    });
    addCase(loadMoreWhatsAppMetaChats.fulfilled, (state, action) => {
      const { chats = [], nextCursor } = action.payload;

      state.whatsappIntegrationMetaChatsListLoadingMore = false;
      state.whatsappIntegrationMetaChatsListNextCursor = nextCursor;
      state.whatsappIntegrationMetaChatsListReachedAt = !nextCursor
        ? null
        : Math.min(...chats.map((chat) => chatRecency(chat)));
      absorbChats(state, chats);
    });
    addCase(loadMoreWhatsAppMetaChats.rejected, (state) => {
      state.whatsappIntegrationMetaChatsListLoadingMore = false;
    });

    addCase(getWhatsAppMetaChatsView.pending, (state, action) => {
      const key = chatsViewKey(action.meta.arg);
      const view = state.whatsappIntegrationMetaChatsView;

      if (action.meta.arg.cursor && view?.key === key) {
        view.loadingMore = true;
        return;
      }

      state.whatsappIntegrationMetaChatsView = {
        key,
        ids: [],
        loading: true,
        loadingMore: false,
      };
    });
    addCase(getWhatsAppMetaChatsView.fulfilled, (state, action) => {
      const view = state.whatsappIntegrationMetaChatsView;

      // A slower answer to something typed a moment ago
      if (!view || view.key !== chatsViewKey(action.meta.arg)) {
        return;
      }

      const chats = action.payload.chats || [];

      absorbChats(state, chats);

      view.ids = action.meta.arg.cursor
        ? [...view.ids, ...chats.map((chat) => chat._id)]
        : chats.map((chat) => chat._id);
      view.nextCursor = action.payload.nextCursor;
      view.loading = false;
      view.loadingMore = false;
    });
    addCase(getWhatsAppMetaChatsView.rejected, (state, action) => {
      const view = state.whatsappIntegrationMetaChatsView;

      if (view && view.key === chatsViewKey(action.meta.arg)) {
        view.loading = false;
        view.loadingMore = false;
      }
    });

    addCase(getWhatsAppMetaChat.fulfilled, (state, action) => {
      absorbChats(state, [action.payload]);
    });

    addCase(getWhatsaAppMetaTemplates.fulfilled, (state, action) => {
      state.whatsappIntegrationMetaTemplates = action.payload.templates;
    });

    addCase(getWhatsappMetaMediaStorage.fulfilled, (state, action) => {
      state.whatsappIntegrationMetaMediaStorage = action.payload;
    });

    addCase(getWhatsappMetaCampaigns.fulfilled, (state, action) => {
      state.whatsappIntegrationMetaCampaigns = action.payload;
      state.whatsappIntegrationMetaCampaignsLoaded = true;
    });

    addCase(getWhatsappMetaNumberHealth.fulfilled, (state, action) => {
      state.whatsappIntegrationMetaNumberHealth = action.payload;
    });

    addCase(getWhatsappMetaComments.fulfilled, (state, action) => {
      if (!state.whatsappIntegrationMetaComments) {
        state.whatsappIntegrationMetaComments = {};
      }

      state.whatsappIntegrationMetaComments[action.meta.arg.conversationId] =
        action.payload.comments || [];
    });

    // The socket repeats all three for everyone on the chat, the author
    // included. Applied here as well so the author's own screen does not
    // depend on the socket being connected at that moment.
    addCase(createWhatsappMetaComment.fulfilled, (state, action) => {
      upsertComment(state, action.payload);
    });

    addCase(updateWhatsappMetaComment.fulfilled, (state, action) => {
      upsertComment(state, action.payload);
    });

    addCase(deleteWhatsappMetaComment.fulfilled, (state, action) => {
      removeComment(state, {
        _id: action.meta.arg.commentId,
        conversationId: action.meta.arg.conversationId,
      });
    });

    addCase(googleDriveOAuthCallback.fulfilled, (state, action) => {
      upsertIntegration(state, action.payload);
    });

    addCase(registerGoogleDrivePickerRoots.fulfilled, (state, action) => {
      upsertIntegration(state, action.payload);
    });

    addCase(listGoogleDriveFiles.pending, (state) => {
      state.googleDriveFilesLoading = true;
    });
    addCase(listGoogleDriveFiles.fulfilled, (state, action) => {
      state.googleDriveFilesLoading = false;
      state.googleDriveFiles = action.payload;
    });
    addCase(listGoogleDriveFiles.rejected, (state) => {
      state.googleDriveFilesLoading = false;
    });

    addCase(createGoogleDriveFile.fulfilled, (state, action) => {
      state.googleDriveFiles = [...state.googleDriveFiles, action.payload];
    });

    addCase(updateGoogleDriveFile.fulfilled, (state, action) => {
      // A rename replaces the row in place; a move (parentId changed) takes
      // it out of the folder currently being viewed.
      const movedAway = Boolean(action.meta.arg.parentId);

      state.googleDriveFiles = movedAway
        ? state.googleDriveFiles.filter((file) => file.id !== action.payload.id)
        : state.googleDriveFiles.map((file) =>
            file.id === action.payload.id ? action.payload : file,
          );
    });

    addCase(deleteGoogleDriveFile.fulfilled, (state, action) => {
      state.googleDriveFiles = state.googleDriveFiles.filter(
        (file) => file.id !== action.meta.arg.fileId,
      );
    });

    addMatcher(
      isAnyOf(createGoogleDriveFile.pending, updateGoogleDriveFile.pending),
      (state) => {
        state.googleDriveFileActionLoading = true;
      },
    );

    addMatcher(
      isAnyOf(
        createGoogleDriveFile.fulfilled,
        createGoogleDriveFile.rejected,
        updateGoogleDriveFile.fulfilled,
        updateGoogleDriveFile.rejected,
      ),
      (state) => {
        state.googleDriveFileActionLoading = false;
      },
    );

    addMatcher(isAnyOf(userActions.logout, revertAllReduxAction), (state) => {
      return (state = initialState as any);
    });
  },
});

export const integrationActions = {
  ...integrationSlice.actions,
  createIntegration,
  disconnectIntegration,
  getUserIntegrations,
  startFBWebhookFinalizeFields,
  finishFBWebhookFinalizeFields,
  updateIntegration,
  getWhatsAppDirectQR,
  syncWhatsappDirectStatus,
  getWhatsAppDirectChatsList,
  getWhatsAppDirectChatMessages,
  getWhatsAppDirectChatDetails,
  whatsAppDirectSendMessage,
  disconnectWhatsAppDirect,
  markChatAsRead,
  createWhatsAppNote,
  //
  getWhatsAppMetaChatsList,
  loadMoreWhatsAppMetaChats,
  getWhatsAppMetaChatsView,
  getWhatsAppMetaChat,
  getWhatsaAppMetaTemplates,
  getWhatsappMetaNumberHealth,
  getWhatsappMetaMediaStorage,
  getWhatsappMetaCampaigns,
  createWhatsappMetaCampaign,
  updateWhatsappMetaCampaign,
  pauseWhatsappMetaCampaign,
  resumeWhatsappMetaCampaign,
  deleteWhatsappMetaCampaign,
  sendWhatsAppMetaMessage,
  markWhatsAppMetaChatAsRead,
  incrementWhatsAppMetaChatUnreadCount,
  createWhatsappMetaConversation,
  updateWhatsappMetaAiAgent,
  getWhatsappMetaMessages,
  showWhatsappMetaTyping,
  sendWhatsappMetaMedia,
  deleteWhatsappMetaMessage,
  reactToWhatsappMetaMessage,
  deleteWhatsappMetaAIAgent,
  setWhatsappMetaConversationHandler,
  assignWhatsappMetaConversation,
  updateWhatsappMetaConversationTags,
  updateWhatsappMetaAutoAssign,
  getWhatsappMetaComments,
  createWhatsappMetaComment,
  updateWhatsappMetaComment,
  deleteWhatsappMetaComment,
  //
  createGoogleDriveAuthLink,
  googleDriveOAuthCallback,
  registerGoogleDrivePickerRoots,
  disconnectGoogleDrive,
  listGoogleDriveFiles,
  createGoogleDriveFile,
  updateGoogleDriveFile,
  deleteGoogleDriveFile,
  downloadGoogleDriveFile,
  //
  connectFacebookMeta,
  getFacebookMetaForms,
  linkFacebookMetaForm,
  unlinkFacebookMetaForm,
  fetchFacebookMetaLeads,
};

export default integrationSlice.reducer;
